const prefix = 'Search for "';
const suffix = '"';
const searchStrings = ["Baby Changing Bag", "Baby Changing Mat", "Nappy Caddy", "Gift Set"];

const wordDuration = 4000; // Word length in milliseconds
const tickDuration = 100; // Tick duration in milliseconds
const ticksPerWord = Math.ceil(wordDuration / tickDuration); // The number of ticks per word

const inputs = document.querySelectorAll("[data-ab-test-predictive-search]");

let tick = 0; // Current tick
setInterval(() => {
  inputs.forEach((input) => (input.placeholder = getStringContent(tick)));
  tick = tick >= ticksPerWord * searchStrings.length ? 0 : tick + 1;
}, tickDuration);

/**
 * Returns a string matching the current frame of the animation
 * @param {number} tick The current tick
 * @returns {string} The string to show for this tick of the animation
 */
function getStringContent(tick) {
  // The index of the current word we're on
  const wordIndex = Math.floor((tick * tickDuration) / wordDuration) % searchStrings.length;

  // The number of ticks we are into this word
  const ticksIntoWord = tick % ticksPerWord;

  // The remaining ticks to show this word for
  const remainingTicks = ticksPerWord - ticksIntoWord;

  // The string to animate
  const matchingWord = searchStrings[wordIndex] + suffix;

  // Return formatted string
  return prefix + matchingWord.slice(0, remainingTicks <= matchingWord.length ? remainingTicks : ticksIntoWord);
}
